(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('exportadorFilterField', ExportadorFilterField);

  function ExportadorFilterField() {
    return {
      restrict: 'E',
      scope: {
        schema: '<',
        value: '='
      },
      controller: 'ExportadorFilterFieldCtrl',
      controllerAs: 'field',
      bindToController: true,
      templateUrl: 'views/directives/exportador-filter-field.html'
    };
  }

}());
